/**
 * @file コンポーネント：フル動画ページ機器広告問い合わせ失敗モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "caution",
                    onClick: (e) => {
                        e.preventDefault();
                        props.setIsOpenModalAdFailure(false);
                        props.setIsOpenModalAdConfirm(true);
                    },
                    text: localized["Label.Ok"],
                },
            ]}
            content={[
                <Paragraph
                    key="content"
                    onColor="white"
                    text={
                        localized["ErrorMessage.FailedSendingYourInforamtion"]
                    }
                />,
            ]}
            hasButtonClose={true}
            headline={localized["Label.Error"]}
            isShow={props.isOpenModalAdFailure}
            setIsShow={() => {
                props.setIsOpenModalAdFailure(false);
                props.setIsOpenModalAdConfirm(true);
            }}
        />
    );
};
